import React from "react";
import $ from "jquery"
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { showAdhocAction, updateAdhocData } from "../../../action/action";
import { CMSPath, globalIV, globalSalt } from "../../../config/constant";
import { saveGuestRequest } from "../../../action/guestRequest";
import { AesUtil } from "../../../JS/AesUtil";
import { closeOrderPopUp } from "../../action/hCommerce2";

const AdhocPopup = (props) => {

    const { t } = props;
    let aesUtil = new AesUtil(128, 1000);
    const adHocPath = "/cmsData/adhocEvents/imgStyles/";

    const [adhocDataListLocalCopy, setAdhocDataListLocalCopy] = React.useState([]);
    const [showSingleAdhoc, setShowSingleAdhoc] = React.useState({
        showSingleAdhocBool: false,
        adhocType: null,
        adhocId: null
    })

    const [pendingRequest, setPendingRequest] = React.useState([]);
    const [acceptedRequest, setAcceptedRequest] = React.useState([]);

    const handleShowSingleAdhoc = (adhoc) => {
        setShowSingleAdhoc({
            showSingleAdhocBool: true,
            adhocType: adhoc.type,
            adhocId: adhoc.id
        })
    }

    const handleClose = () => {

        const adHocEventShownIDList = JSON.parse(localStorage.getItem("adHocEventShownIDList")) || [];
        const serverDate = props.serverTimeDatePayload.date && props.serverTimeDatePayload.date.split("T")[0];

        const updatedAdHocEventShownIDList = [...adHocEventShownIDList];

        adhocDataListLocalCopy.forEach(adhoc => {
            const shownAdhocData = {
                id: adhoc.id,
                triggerType: adhoc.type,
                adhocEventShownDate: serverDate
            };

            const existingIndex = updatedAdHocEventShownIDList.findIndex(event =>
                event.id === shownAdhocData.id && event.triggerType === shownAdhocData.triggerType
            );

            if (existingIndex > -1) {
                updatedAdHocEventShownIDList[existingIndex] = shownAdhocData;
            } else {
                updatedAdHocEventShownIDList.push(shownAdhocData);
            }
        });

        localStorage.setItem("adHocEventShownIDList", JSON.stringify(updatedAdHocEventShownIDList));
        props.updateAdhocData([]);
        props.showAdhocAction(false);
    }

    const handleBack = () => {
        setShowSingleAdhoc({
            showSingleAdhocBool: false,
            adhocType: null,
            adhocId: null
        })
    }


    const removePendingRequestData = (data) => {
        setPendingRequest((prevRequests) =>
            prevRequests.filter(
                (request) =>
                    !(request.adhocId === data.adhocId && request.adhocType == data.adhocType && request.qualityPlusRequestId === data.qualityPlusRequestId)
            )
        );
    };

    const addPendingRequestData = (data) => {

        let pendingRequestData = {
            adhocId: data.adhocId,
            adhocType: data.adhocType,
            qualityPlusRequestId: data.qualityPlusRequestId
        }

        setPendingRequest((prevRequests) => {
            const isPresent = prevRequests.some(
                (request) =>
                    request.adhocId === pendingRequestData.adhocId && request.adhocType == pendingRequestData.adhocType && request.qualityPlusRequestId === pendingRequestData.qualityPlusRequestId
            );
            if (!isPresent) {
                return [...prevRequests, pendingRequestData];
            }
            return prevRequests;
        });
    };


    const addAcceptedRequestData = (data) => {
        let pendingRequestData = {
            adhocId: data.adhocId,
            adhocType: data.adhocType,
            qualityPlusRequestId: data.qualityPlusRequestId
        }

        setAcceptedRequest((prevData) => {
            const isPresent = prevData.some(
                (request) =>
                    request.adhocId === pendingRequestData.adhocId && request.adhocType == pendingRequestData.adhocType && request.qualityPlusRequestId === pendingRequestData.qualityPlusRequestId
            );
            if (!isPresent) {
                return [...prevData, pendingRequestData];
            }
            return prevData;
        });
    }


    const handleRemoveUpsellFromList = (adhocId, adhocType, qualityPlusRequestId) => {
        const updatedAdhocDataList = adhocDataListLocalCopy.map((adhocData) => {
            if (adhocData.id === adhocId && adhocData.type == adhocType) {
                return {
                    ...adhocData,
                    qualityPlusRequestList: adhocData.qualityPlusRequestList.filter(
                        (qualityPlusRequestData) => qualityPlusRequestData.id !== qualityPlusRequestId
                    ),
                };
            }
            return adhocData;
        });

        setAdhocDataListLocalCopy(updatedAdhocDataList);
    }


    const handleUpsellRequestResponse = (status, msg, pendingRequestData) => {

        removePendingRequestData(pendingRequestData);

        if (status) {
            props.closeOrderPopUp(true, "", msg || t('adHoc.request_sent_msg'), false);
            // handleRemoveUpsellFromList(pendingRequestData.adhocId, pendingRequestData.adhocType, pendingRequestData.qualityPlusRequestId)
            addAcceptedRequestData(pendingRequestData);
        } else {
            props.closeOrderPopUp(true, "", msg || t('adHoc.something_went_wrong'), true);
        }
    }

    const handleUpsellRequest = (adhocData, qualityPlusRequestId) => {


        let pendingRequestData = {
            adhocId: adhocData.id,
            adhocType: adhocData.type,
            qualityPlusRequestId: qualityPlusRequestId
        }

        addPendingRequestData(pendingRequestData)

        let guestInfo = {};

        if (localStorage.getItem("Set_Current_Logged_In_Guest_Details")) {
            guestInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
        } else if (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            guestInfo = JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
        }

        if (!guestInfo.reservationNumber) {
            removePendingRequestData(pendingRequestData)
            props.closeOrderPopUp(true, "", t('adHoc.something_went_wrong'), true);
            return;
        }

        console.log("we are here")
        console.log(guestInfo)
        props.saveGuestRequest(
            guestInfo,
            localStorage.getItem("GuestJourneySessionToken"),
            [qualityPlusRequestId],
            "",
            (status, msg) => handleUpsellRequestResponse(status, msg, pendingRequestData)
        );
    }


    const removeRequestedQps = (adhocData) => {

        return adhocData.map(event => {

            const updatedQualityPlusRequestList = event.qualityPlusRequestList && event.qualityPlusRequestList.length > 0 && event.qualityPlusRequestList.filter(qps => !qps.isRequested) || [];

            // Return the updated event object with the filtered qualityPlusRequestList

            if (event.multimediaType != "Upsell" || (event.multimediaType == "Upsell" && updatedQualityPlusRequestList.length > 0)) {
                return {
                    ...event,
                    qualityPlusRequestList: updatedQualityPlusRequestList
                };
            }

            return null;
        }).filter(event => event !== null);
    }

    React.useEffect(() => {

        const updatedAdhocData = removeRequestedQps(props.adhocData);

        if (updatedAdhocData.length > 0) {
            setAdhocDataListLocalCopy(updatedAdhocData);
            $("body").addClass("overlay-cast");
        } else {
            handleClose();
        }

        return () => {
            $("body").removeClass("overlay-cast");
        }
    }, [])

    return adhocDataListLocalCopy.length > 0 && (

        <div className={`main-container show-adhoc`}>

            <header class="inner-pages subpages">
                <a onClick={handleClose} class="button-next"></a>
                <div class="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>


            {!showSingleAdhoc.showSingleAdhocBool ?
                <section class="widgets spa-listing">
                    <div class="widget-header">
                        <div class="widget-header-title">{t('adHoc.heading')}</div>
                        <div class="widget-header-subtitle">{t('adHoc.sub_heading')}</div>
                    </div>

                    <div class="widgets">
                        {
                            adhocDataListLocalCopy.map((adhoc) => {
                                return (
                                    <div class="widgets">

                                        <div class="row offers-list" onClick={() => handleShowSingleAdhoc(adhoc)}>
                                            <div class="row offer-item">

                                                {adhoc.imageUri && <div class="offer-img">
                                                    <img src={`${CMSPath}${adHocPath}${adhoc.imageUri}`} />
                                                </div>}


                                                <div class="offer-body">
                                                    <div class="offer-title" style={{ color: "#000 !important" }} dangerouslySetInnerHTML={{ __html: adhoc.name }} ></div>
                                                    <div class="offer-body-text" dangerouslySetInnerHTML={{ __html: adhoc.textMessage }} ></div>
                                                </div>

                                            </div>
                                        </div>

                                        {adhoc.qualityPlusRequestList && adhoc.qualityPlusRequestList.length > 0 &&
                                            <div class="widgets">
                                                {
                                                    adhoc.qualityPlusRequestList.map((qualityPlusRequest) => (


                                                        <div class="row offers-list">
                                                            <div class="row offer-item">


                                                                {qualityPlusRequest.imageName && <div class="offer-img">
                                                                    <img src={`${CMSPath}${adHocPath}${qualityPlusRequest.imageName}`} />
                                                                </div>}



                                                                <div class="offer-body">
                                                                    <div class="offer-title" style={{ color: "#000 !important" }} dangerouslySetInnerHTML={{ __html: qualityPlusRequest.name }} ></div>
                                                                    <div class="offer-body-text" dangerouslySetInnerHTML={{ __html: qualityPlusRequest.description }} ></div>
                                                                </div>



                                                                <div class="offer-controls">
                                                                    <div class="offer-pricing">
                                                                        {qualityPlusRequest.price &&
                                                                            <>
                                                                                <div class="offer-pricing-heading">{t(`adHoc.price`)}</div>
                                                                                <div class="offer-pricing-amount">{qualityPlusRequest.price}</div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                    <div class="offer-buttons">
                                                                        {
                                                                            pendingRequest.some((pendingRequestData) => {
                                                                                return adhoc.id == pendingRequestData.adhocId && adhoc.type == pendingRequestData.adhocType && qualityPlusRequest.id == pendingRequestData.qualityPlusRequestId;
                                                                            }) ?
                                                                                <>
                                                                                    <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('adHoc.accepting')}</button> :
                                                                                    {/* <button disabled class="button">{t('adHoc.remove')}</button> */}
                                                                                </>
                                                                                :
                                                                                acceptedRequest.some((acceptedRequestData) => {
                                                                                    return adhoc.id == acceptedRequestData.adhocId && adhoc.type == acceptedRequestData.adhocType && qualityPlusRequest.id == acceptedRequestData.qualityPlusRequestId;
                                                                                })
                                                                                    ?
                                                                                    <>
                                                                                        <button disabled class="button">{t('adHoc.accepted')}</button>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <button onClick={() => handleUpsellRequest(adhoc, qualityPlusRequest.id)} class="button">{t('adHoc.accept')}</button>
                                                                                        {/* <button onClick={() => handleRemoveUpsellFromList(adhoc.id, adhoc.type, qualityPlusRequest.id)} class="button">{t('adHoc.remove')}</button> */}
                                                                                    </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </section>
                :
                <section class="widgets spa-listing">
                    <>
                        {
                            adhocDataListLocalCopy.map((adhoc) => (
                                adhoc.id === showSingleAdhoc.adhocId && adhoc.type == showSingleAdhoc.adhocType && (
                                    <>
                                        <div class="widget-header">
                                            {adhoc.imageUri &&
                                                <div class="widget-header-img">
                                                    <img src={`${CMSPath}${adHocPath}${adhoc.imageUri}`} />
                                                </div>
                                            }
                                            <div class="widget-header-title" dangerouslySetInnerHTML={{__html: adhoc.name}}></div>
                                            <div class="widget-header-subtitle" dangerouslySetInnerHTML={{__html: adhoc.textMessage}}></div>
                                        </div>

                                        <div class="widgets offers-sub-page">

                                            <div class="row offers-list">
                                                <div class="row offer-item">

                                                    {adhoc.qualityPlusRequestList && adhoc.qualityPlusRequestList.length > 0 &&
                                                        <div class="widgets">
                                                            {
                                                                adhoc.qualityPlusRequestList.map((qualityPlusRequest) => (


                                                                    <div class="row offers-list">
                                                                        <div class="row offer-item">


                                                                            {qualityPlusRequest.imageName && <div class="offer-img">
                                                                                <img src={`${CMSPath}${adHocPath}${qualityPlusRequest.imageName}`} />
                                                                            </div>}



                                                                            <div class="offer-body">
                                                                                <div class="offer-title" style={{ color: "#000 !important" }} dangerouslySetInnerHTML={{ __html: qualityPlusRequest.name }} ></div>
                                                                                <div class="offer-body-text" dangerouslySetInnerHTML={{ __html: qualityPlusRequest.description }} ></div>
                                                                            </div>



                                                                            <div class="offer-controls">
                                                                                <div class="offer-pricing">
                                                                                    {qualityPlusRequest.price &&
                                                                                        <>
                                                                                            <div class="offer-pricing-heading">{t(`adHoc.price`)}</div>
                                                                                            <div class="offer-pricing-amount">{qualityPlusRequest.price}</div>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                                <div class="offer-buttons">
                                                                                    {
                                                                                        pendingRequest.some((pendingRequestData) => {
                                                                                            return adhoc.id == pendingRequestData.adhocId && adhoc.type == pendingRequestData.adhocType && qualityPlusRequest.id == pendingRequestData.qualityPlusRequestId;
                                                                                        }) ?
                                                                                            <>
                                                                                                <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('adHoc.accepting')}</button> :
                                                                                                {/* <button disabled class="button">{t('adHoc.remove')}</button> */}
                                                                                            </>
                                                                                            :
                                                                                            acceptedRequest.some((acceptedRequestData) => {
                                                                                                return adhoc.id == acceptedRequestData.adhocId && adhoc.type == acceptedRequestData.adhocType && qualityPlusRequest.id == acceptedRequestData.qualityPlusRequestId;
                                                                                            })
                                                                                                ?
                                                                                                <>
                                                                                                    <button disabled class="button">{t('adHoc.accepted')}</button>
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    <button onClick={() => handleUpsellRequest(adhoc, qualityPlusRequest.id)} class="button">{t('adHoc.accept')}</button>
                                                                                                    {/* <button onClick={() => handleRemoveUpsellFromList(adhoc.id, adhoc.type, qualityPlusRequest.id)} class="button">{t('adHoc.remove')}</button> */}
                                                                                                </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div class="multi-tips-controls">
                                            <button class="button secondary w-100" onClick={handleBack} >{t('adHoc.back')}</button>
                                        </div>
                                    </>
                                )
                            ))
                        }
                    </>
                </section>
            }
        </div >
    )

}

const mapStateToProps = state => {

    return {
        adhocData: state.store2.adhocData,
        serverTimeDatePayload: state.store.home.serverTimeDate || {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    }
}

export default connect(mapStateToProps, { showAdhocAction, updateAdhocData, showAdhocAction, saveGuestRequest, closeOrderPopUp })(withTranslation('translations')(AdhocPopup));